<nb-action class="close-dialog" icon="close-outline" (click)="closeAction()"></nb-action>
<nb-card>
    <nb-card-header>Déconnexion</nb-card-header>
    <nb-card-body>
        <div class="row">
            <div class="col-sm-12">
                <div class="form">
                    <p>Êtes-vous sûr de vouloir vous déconnecter ?</p>
                </div>
            </div>
        </div>

    </nb-card-body>
    <nb-card-footer>
        <button nbButton fullWidth status="danger" shape="round" (click)="logoutAction()" class="mb-2"
            [disabled]="(loading)">Confirmer</button>
    </nb-card-footer>
</nb-card>